import { Link } from "react-router-dom";
import { Eyebrow } from "@/components/shared";
import { Building2, Users, Server, BarChart3, ArrowRight } from "lucide-react";

export default function MSP() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
      <Eyebrow>For MSPs</Eyebrow>
      <h1 className="max-w-3xl font-display text-4xl font-extrabold tracking-tight text-slate-50 sm:text-5xl">Offsite backups for every client you manage.</h1>
      <p className="mt-4 max-w-2xl text-slate-400">ZettaKeep is built multi-tenant from the ground up. Manage multiple client organizations, sites and PBS servers from one place — with white-labeling on the roadmap.</p>

      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {[[Building2, "Client organizations", "Isolated tenants per client, each with their own servers, storage and credentials."],
          [Server, "PBS fleet", "See every client's backup server, region and health in one dashboard."],
          [Users, "Team roles", "Owner, Administrator, Backup Administrator, Billing and Read-Only — enforced server-side."],
          [BarChart3, "Consolidated view", "Backup status, failures, storage and billing across your entire book of business."]].map(([Icon, t, d]) => (
          <div key={t} className="rounded-xl border border-slate-800 bg-slate-900/40 p-6">
            <Icon className="h-6 w-6 text-cyan-400" />
            <div className="mt-4 font-display font-semibold text-slate-100">{t}</div>
            <p className="mt-1.5 text-sm text-slate-400">{d}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 rounded-2xl border border-cyan-500/20 bg-gradient-to-br from-slate-900 to-[#06080D] p-8">
        <h2 className="font-display text-xl font-bold text-slate-100">Talk to us about MSP volume pricing</h2>
        <p className="mt-2 max-w-2xl text-slate-400">Running backups for many clients? We offer custom quotes and consolidated billing.</p>
        <Link to="/contact" className="mt-5 inline-flex items-center gap-2 rounded-lg bg-cyan-400 px-6 py-3 font-semibold text-[#06080D] hover:bg-cyan-300">Contact Sales <ArrowRight className="h-4 w-4" /></Link>
      </div>
    </div>
  );
}
